import {
  CompetitionSelector,
  DateRangeSelector,
  FilterPanel,
  FilterScopeProvider,
  ResetAllFiltersButton,
  SeasonSelector,
  TeamSelector,
} from '@statsbomb/kitbag-global-football';
import { useAtomValue } from 'jotai';
import { unwrap } from 'jotai/utils';
import { competitionOptionsAtom, defaultCompetitionSectionCycleAtom } from '@/atoms/filters/highLevel/competitions';
import { seasonOptionsAtom } from '@/atoms/filters/highLevel/seasons';
import { teamOptionsAtom } from '@/atoms/filters/highLevel/teams';
import { usePhysicalMetricsFeature } from '@/hooks/featureFlags';

const unwrappedCompetitionOptionsAtom = unwrap(competitionOptionsAtom, prev => prev ?? []);
const unwrappedSeasonOptionsAtom = unwrap(seasonOptionsAtom, prev => prev ?? []);
const unwrappedTeamOptionsAtom = unwrap(teamOptionsAtom, prev => prev ?? []);
const unwrappedCyclesAtom = unwrap(defaultCompetitionSectionCycleAtom, prev => prev ?? []);

const DataLockerTeamHighLevelFiltersContent = () => {
  const competitionOptions = useAtomValue(unwrappedCompetitionOptionsAtom);
  const seasonOptions = useAtomValue(unwrappedSeasonOptionsAtom);
  const teamOptions = useAtomValue(unwrappedTeamOptionsAtom);
  const cycles = useAtomValue(unwrappedCyclesAtom);
  const showTracking = usePhysicalMetricsFeature();

  return (
    <FilterPanel>
      <ResetAllFiltersButton />
      <CompetitionSelector options={competitionOptions} playerCycles={cycles} showTracking={showTracking} />
      <SeasonSelector options={seasonOptions} />
      <TeamSelector options={teamOptions} />
      <DateRangeSelector />
    </FilterPanel>
  );
};

export const DataLockerTeamHighLevelFilters = () => (
  <FilterScopeProvider scope="main">
    <DataLockerTeamHighLevelFiltersContent />
  </FilterScopeProvider>
);
